import Skeleton from "react-loading-skeleton";

import Badge from "ds/components/Badge";
import useUserGuideGroup from "shared/UserGuides/useUserGuideGroup";

import useAssistantPanelLearnStore from "../../useStore";

const AssistantPanelLearnMissionHeaderTitle = () => {
  const { navigationState } = useAssistantPanelLearnStore();
  const groupId = navigationState.level === "groups" ? "" : navigationState.groupId;
  const { userGuideGroup, loading } = useUserGuideGroup({ id: groupId });

  if (navigationState.level === "groups") {
    return null;
  }

  if (loading && !userGuideGroup) {
    return <Skeleton width={120} height={20} borderRadius={10} />;
  }

  if (!userGuideGroup) {
    return null;
  }

  return (
    <Badge type="weak" variant="gray" text={userGuideGroup.name} textEllipsis />
  );
};

export default AssistantPanelLearnMissionHeaderTitle;
